import {loadLoginStatus, loadStudent, loadRooms, loadTeachers, saveAdmin, loadAdmin,} from '../../utils/cache'
import { saveLoginStatus, saveStudent, saveRooms, saveTeachers, } from '../../utils/cache'

const user = {
  state: {
    loginStatus: loadLoginStatus(),//登录状态
    student: loadStudent(),//用户登录信息
    rooms: loadRooms(),
    teachers: loadTeachers(),
    admin: loadAdmin(),
  },

  mutations: {
    set_student(state, student) {
      state.student = student
    },
    set_login_status(state, loginStatus) {
      state.loginStatus = loginStatus
    },
    set_rooms(state, rooms) {
      state.rooms = rooms
    },
    set_teachers(state, teachers) {
      state.teachers = teachers
    },
    set_admin(state, admin) {
      state.admin = admin
    },
  },

  actions: {
    //设置状态
    setLoginStatus(context, query) {
      // console.log('开始 state setLoginStatus query：'+query)
      context.commit('set_login_status', saveLoginStatus(query))
    },
    //保存用户个人信息
    setStudent(context, shengyaUser) {
      console.log('开始 state setStudent current: ' +Date.now())
      context.commit('set_student', saveStudent(shengyaUser))
    },
    //
    setRooms(context, rooms) {
      console.log('开始 state setRooms current: ' +Date.now())
      context.commit('set_rooms', saveRooms(rooms))
    },
    //
    setTeachers(context, teachers) {
      console.log('开始 state setTeachers current: ' +Date.now())
      context.commit('set_teachers', saveTeachers(teachers))
    },
    //
    setAdmin(context, admin) {
      console.log('开始 state setAdmin current: ' +Date.now())
      context.commit('set_admin', saveAdmin(admin))
    },
  }
}

export default user
